/** IDs are references only; the current authenticated snapshot owns their content and authority. */
export function attentionMetadata(value) {
    const ids = value.attentionQuestionIds;
    if (ids === undefined)
        return value.attentionUnavailable === true ? { attentionUnavailable: true } : {};
    if (!Array.isArray(ids) || ids.length > 12 || ids.some(id => typeof id !== 'string' || !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(id))
        || new Set(ids).size !== ids.length)
        return { attentionUnavailable: true };
    return { attentionQuestionIds: ids, ...(value.attentionUnavailable === true ? { attentionUnavailable: true } : {}) };
}
//# sourceMappingURL=metadata.js.map